























































import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";
import { useThemeStore } from "@/shared/store/theme";
import { HsabEnrollmentSettingsResponse,
  HsabEnrollmentSettingsUpdateRequest } from "@/shared/types";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useHsabEnrollmentStore } from "@/employee/store/hsabEnrollment";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
@Component({
  components: { GenericLoadingSpinner }
})
export default class HsabEnrollmentSettingsForm extends Vue {
  themeStore = useThemeStore();
  hsabAccountsStore = useHsabAccountsStore();
  hsabEnrollmentStore = useHsabEnrollmentStore();
  @Prop()
  showModal: boolean;
  @Prop()
  currentSettings: HsabEnrollmentSettingsResponse;
  editForm: HsabEnrollmentSettingsUpdateRequest = {
    linkHealthCareData: false,
    autoFileClaim: false,
    autoFileHsa: false
  };
  isSaving = false;

  @Watch("showModal")
  showModalChanged () {
    if (this.currentSettings && this.showModal) {
      this.editForm = {
        linkHealthCareData: this.currentSettings.linkHealthCareData,
        autoFileHsa: this.currentSettings.autoFileHsa,
        autoFileClaim: this.currentSettings.autoFileClaim
      };
    }
  }

  get saveDisabled () {
   return this.currentSettings &&
          this.editForm.linkHealthCareData === this.currentSettings.linkHealthCareData &&
          this.editForm.autoFileHsa === this.currentSettings.autoFileHsa &&
          this.editForm.autoFileClaim === this.currentSettings.autoFileClaim;
  }
  handleOnSave () {
    this.isSaving = true;
    this.hsabEnrollmentStore.saveHsabEnrollmentSettings(this.editForm).then(res => {
      this.isSaving = false;
      this.$emit("save-action", this.editForm);
    });
  }
  handleOnCancel () {
    this.$emit("edit-closed");
  }
  handleLinkHealthCareDataChange () {
    if (!this.editForm.linkHealthCareData) {
      this.editForm.autoFileClaim = false;
      this.editForm.autoFileHsa = false;
    }
  }
  get isLoaded (): boolean {
    return this.hsabEnrollmentStore.isLoaded;
  }
}
